import { Injectable } from '@angular/core';
import { DbService } from '../db/db.service';
import { Testimonial } from 'src/app/models/firebase/testimonial';
import { isNullOrUndefined } from '@pineapplelab/util';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Project } from 'src/app/models/firebase/project';
import { Clients } from 'src/app/models/firebase/client';

@Injectable({
  providedIn: 'root'
})
export class TestimonialsService {
  constructor(
    private dbService: DbService,
    private firestore:  AngularFirestore,
  ) { }

  async saveTestimonial(model: Testimonial, projectId: string, clientId: string) {
    if (isNullOrUndefined(model.id)) {
        model.id = this.dbService.createId();
    }
    const json = model.toJson();

    Promise.all([
        await this.firestore.collection(Project.PATH).doc(projectId).collection(Clients.PATH)
        .doc(clientId).collection(Testimonial.PATH).doc(model.id).set(json, { merge: true }),
        await this.firestore.collection(Project.PATH).doc(projectId).collection(Testimonial.PATH)
        .doc(model.id).set(json, { merge: true })
    ]);
  }

  async getTestimonials(projectId: string) {
    const testimonials:Testimonial[] = [];
    const res = await this.dbService.firestore.collection(Project.PATH).doc(projectId).collection(Testimonial.PATH).get();
    res.docs.map((x) => {
        let testimonial = new Testimonial(x.data());
        testimonials.push(testimonial);
    });
    return testimonials;
  }
  async getTestimonialsHomePage(projectId: string) {
    const testimonials:Testimonial[] = [];
    const res = await this.dbService.firestore.collection(Project.PATH).doc(projectId).collection(Testimonial.PATH).limit(3).get();
    res.docs.map((x) => {
        let testimonial = new Testimonial(x.data());
        testimonials.push(testimonial);
    });
    return testimonials;
  }

}
